import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import { FaEye, FaTrash, FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteModal from "../../../components/Modal/DeleteModal";
import { languageHelper } from "../../../config/helperFunctions";

function InventoryAdjustment() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      cell: (row) => row?.row?.index + 1,
    },
    {
      header: languageHelper("Reference No") || "Reference No",
      accessorKey: "reference_no",
    },
    {
      header: languageHelper("Date") || "Date",
      accessorKey: "date",
    },
    {
      header: languageHelper("Ingredient Count") || "Ingredient Count",
      accessorKey: "items",
      cell: (info) => info?.getValue()?.length,
    },
    {
      header: languageHelper("Responsible Person") || "Responsible Person",
      accessorKey: "responsible_person",
      cell: (info) => info?.getValue()?.name,
    },
    {
      header: languageHelper("Note") || "Note",
      accessorKey: "note",
    },

    {
      header: languageHelper("Added By") || "Added By",
      accessorKey: "added_by",
      cell: (info) => info?.getValue()?.name,
    },
    {
      header: languageHelper("Actions") || "Actions",
      accessorKey: "total",
      cell: (row) => (
        <Dropdown options={dropdownOptions} id={row?.row?.original?.id} />
      ),
    },
  ];
  const [data, setData] = useState([]);
  const [selectedId, setselectedId] = useState(false);
  const buttonData = [
    {
      buttonText:
        languageHelper("Add Inventory Adjustments") ||
        "Add Inventory Adjustments",
      path: "addInventoryAdjForm",
    },
  ];
  const navigate = useNavigate();
  const dropdownOptions = [
    {
      name: languageHelper("View"),
      icon: <FaEye />,
      func: (id) => {
        // Handle edit action
        navigate(`view/${id}`);
      },
    },
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        // Handle edit action
        navigate(`addInventoryAdjForm/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrash />,
      func: (id) => {
        // Handle delete action
        setselectedId(id);
      },
    },
  ];

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/inventoryadjustment/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        fetchData();
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/inventoryadjustment`, {
        headers: { Authorization: `Bearer ${user?.token}` },
        params: {
          outlet_id: user?.user?.outlet_id,
        },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [user?.token, user?.user?.outlet_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper("Inventory Adjustments") || "Inventory Adjustments"}
        buttonData={buttonData}
      />
      {selectedId && (
        <DeleteModal
          setIsOpen={setselectedId}
          onDelete={() => handleDelete(selectedId)}
        />
      )}
    </main>
  );
}

export default InventoryAdjustment;
